import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=c8196caa&scoped=true&"
import script from "./TabMenu.vue?vue&type=script&lang=js&"
export * from "./TabMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=c8196caa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8196caa",
  null
  
)

export default component.exports